// extracted by mini-css-extract-plugin
export var container = "AppDownload-module--container--7c276";
export var downloadButtonsContainer = "AppDownload-module--downloadButtonsContainer--4b36d";